var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49,
    height: 95,
    viewBox: "0 0 49 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2876 0.757812H24.4492V94.3249H48.2876V0.757812Z",
    fill: "#E1AE81",
    stroke: "#453D3D",
    strokeWidth: 0.680871,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9414 7.6543H29.6167V33.0919H44.9414V7.6543Z",
    fill: "url(#paint0_linear_1068_27333)",
    stroke: "#453D3D",
    strokeWidth: 0.680871,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9414 36.001H29.6167V61.4385H44.9414V36.001Z",
    fill: "url(#paint1_linear_1068_27333)",
    stroke: "#453D3D",
    strokeWidth: 0.680871,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9414 65.0186H29.6167V80.9368H44.9414V65.0186Z",
    fill: "url(#paint2_linear_1068_27333)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9414 65.0186H29.6167V80.9368H44.9414V65.0186Z",
    fill: "url(#paint3_linear_1068_27333)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9414 65.0186H29.6167V80.9368H44.9414V65.0186Z",
    stroke: "#453D3D",
    strokeWidth: 0.680871,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3549 44.8672C27.8775 44.8672 28.3011 45.4567 28.3011 46.1839V60.1969C28.3011 60.9241 27.8775 61.5137 27.3549 61.5137C26.8323 61.5137 26.4087 60.9241 26.4087 60.1969V46.1839C26.4087 45.4567 26.8323 44.8672 27.3549 44.8672Z",
    fill: "#644F3D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9794 83.8838H30.173H24.6559V94.3244H30.173H43.9794H48.2876V83.8838H43.9794Z",
    fill: "#B3B3B3",
    stroke: "#453D3D",
    strokeWidth: 0.680871,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4492 0.757812H0.61084V94.3249H24.4492V0.757812Z",
    fill: "#E1AE81",
    stroke: "#453D3D",
    strokeWidth: 0.680871,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3271 7.6543H4.00244V33.0919H19.3271V7.6543Z",
    fill: "url(#paint4_linear_1068_27333)",
    stroke: "#453D3D",
    strokeWidth: 0.680871,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3271 36.002H4.00244V61.4395H19.3271V36.002Z",
    fill: "url(#paint5_linear_1068_27333)",
    stroke: "#453D3D",
    strokeWidth: 0.680871,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3271 65.0186H4.00244V80.9368H19.3271V65.0186Z",
    fill: "url(#paint6_linear_1068_27333)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3271 65.0186H4.00244V80.9368H19.3271V65.0186Z",
    fill: "url(#paint7_linear_1068_27333)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3271 65.0186H4.00244V80.9368H19.3271V65.0186Z",
    stroke: "#453D3D",
    strokeWidth: 0.680871,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5439 44.8691C22.0665 44.8691 22.4901 45.4669 22.4901 46.2044V60.1804C22.4901 60.9178 22.0665 61.5156 21.5439 61.5156C21.0213 61.5156 20.5977 60.9178 20.5977 60.1804V46.2044C20.5977 45.4669 21.0213 44.8691 21.5439 44.8691Z",
    fill: "#644F3D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7944 83.8838H5.45616H0.98326V94.3244H5.45616H18.7944H24.2334V83.8838H18.7944Z",
    fill: "#B3B3B3",
    stroke: "#453D3D",
    strokeWidth: 0.680871,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1068_27333",
    x1: 37.279,
    y1: 7.6543,
    x2: 37.279,
    y2: 33.0919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1068_27333",
    x1: 37.279,
    y1: 36.001,
    x2: 37.279,
    y2: 61.4385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1068_27333",
    x1: 37.279,
    y1: 65.0186,
    x2: 37.279,
    y2: 80.9368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1068_27333",
    x1: 37.279,
    y1: 65.0186,
    x2: 37.279,
    y2: 80.9368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1068_27333",
    x1: 11.6648,
    y1: 7.6543,
    x2: 11.6648,
    y2: 33.0919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1068_27333",
    x1: 11.6648,
    y1: 36.002,
    x2: 11.6648,
    y2: 61.4395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1068_27333",
    x1: 11.6648,
    y1: 65.0186,
    x2: 11.6648,
    y2: 80.9368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1068_27333",
    x1: 11.6648,
    y1: 65.0186,
    x2: 11.6648,
    y2: 80.9368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDoor);
export default __webpack_public_path__ + "static/media/CloseDoor.9914c1f6f0ad5a4660d5.svg";
export { ForwardRef as ReactComponent };